var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogComponent',{attrs:{"cancelLabel":"not now"},on:{"cancel":_vm.closeModal,"continue":function($event){return _vm.setModal(_vm.Modals.idCardVerification.code)}}},[_c('Intro',{attrs:{"daysRemaining":_vm.daysRemaining}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3675bbde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modals/modals/userProfile/idCardVerification/IdCardVerificationIntroModal.vue
// module id = 2568
// module chunks = 0